module.exports = __webpack_public_path__ + "static/img/17.ab90f33.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/17.png
// module id = uKVt
// module chunks = 1